import { createSelector } from 'reselect';
import get from 'lodash/get';
import {
  supportDataOrEmptyObjectSelector,
  previousSupportDataOrEmptyObjectSelector,
} from '../../AdvWorkflow/AdvWorkflowSelector';
import { BACKEND_KEY } from '../PersonalInfoWorkflowConstants';
import { PARTNER_NAME, AGES, INCOME } from '../../Summaries/SummaryConstants';
import dictionarySelector from '../../Summaries/SummaryDictionarySelector';

const nextIteratorsSelector = createSelector(
  supportDataOrEmptyObjectSelector,
  previousSupportDataOrEmptyObjectSelector,
  dictionarySelector,
  (supportData, previousSupportData, dictionary) => {
    const hasPartner = get(supportData, `${BACKEND_KEY}.HasPartner`);
    if (hasPartner === get(previousSupportData, `${BACKEND_KEY}.HasPartner`)) {
      return [];
    }
    if (hasPartner === true) {
      return [PARTNER_NAME, AGES, INCOME].map(dependencies => dictionary[dependencies].iterator);
    }
    return [];
  },
);

export const dirtyGraphNodesSelector = createSelector(
  supportDataOrEmptyObjectSelector,
  previousSupportDataOrEmptyObjectSelector,
  (supportData, previousSupportData) => {
    const hasPartner = get(supportData, `${BACKEND_KEY}.HasPartner`);
    if (hasPartner === get(previousSupportData, `${BACKEND_KEY}.HasPartner`)) {
      return [];
    }
    return [
      'Income',
      'Accounts',
      'AccountTypes',
      'AccountTypesGroups',
      'AccountOwners',
      'DebtAccounts',
      'DebtAccountTypes',
      'Pensions',
      'PensionTypes',
      'PensionOwners',
    ];
  },
);

export default nextIteratorsSelector;
